import React from 'react'
import Profile from '../../components/student/Profile'
import Box from '../../components/Box'

export default function ProfilePage() {
    return (
        <Box className="mt-3 md:max-w-4xl  mx-auto">
            <h1 className='text-2xl text-center'> Profile Details </h1>
            <div className='flex flex-wrap'>
                <Profile />
            </div>
        </Box>
    )
}
